// ** Fonction permettant un scroll haut de page quand on clique sur les boutons suivant ou retour */
export const scrollToTop = () => {
  const element = document.getElementsByClassName("header");
  if (element) {
    window.scrollTo(0, 0);
  }
};

//** Fonction permettant de cibler les erreurs et de remonter à la première */
export const scrollToReview = () => {
  const elements = document.querySelectorAll(".is-invalid");
  elements.forEach((elem, i) => {
    if (i === 0) {
      elem.scrollIntoView({ block: "center" });
    }
  });
};